/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftHistoryListRequest model module.
 * @module model/EventsControllerDtoEventFreeNftHistoryListRequest
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftHistoryListRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftHistoryListRequest</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftHistoryListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        EventsControllerDtoEventFreeNftHistoryListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftHistoryListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftHistoryListRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftHistoryListRequest} The populated <code>EventsControllerDtoEventFreeNftHistoryListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftHistoryListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
            if (data.hasOwnProperty('searchType')) {
                obj['searchType'] = ApiClient.convertToType(data['searchType'], 'String');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftHistoryListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftHistoryListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of EventsControllerDtoEventFreeNftHistoryListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['searchType'] && !(typeof data['searchType'] === 'string' || data['searchType'] instanceof String)) {
            throw new Error("Expected the field `searchType` to be a primitive type in the JSON string but got " + data['searchType']);
        }
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}

EventsControllerDtoEventFreeNftHistoryListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['freenftNo'] = undefined;

/**
 * @member {String} searchType
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['searchType'] = undefined;

/**
 * @member {String} searchString
 */
EventsControllerDtoEventFreeNftHistoryListRequest.prototype['searchString'] = undefined;






export default EventsControllerDtoEventFreeNftHistoryListRequest;

